import { useLingui } from '@lingui/react/macro';

import config from '@/config';
import Button from '@/design_system/Button';
import IconPrint from '@/icons/Print.svg';
import useViewPort from '@/utils/useViewport';

export const ArticlePrintArticleSheetActionCell = ({ article }: { article: { id: string } }) => {
  const { t } = useLingui();
  const { isMobile } = useViewPort();

  const label = t({ id: 'article.print-item-sheet.message', message: 'Print' });

  return (
    <Button
      size="medium"
      variant="secondary"
      iconOnly={!isMobile}
      href={config.apiUrl + `/articles/${article.id}/item-sheet`}
      download
      ariaLabel={label}
      tooltip={label}
      style={{ flex: 1 }}
    >
      <IconPrint />
      {isMobile && <div>{label}</div>}
    </Button>
  );
};
